export default {
  methods: {
    __sizingVars(size, icon, iconSeparator, putIconOutside) {
      switch (size) {
        case 'normal':
          return {
            '--height': '30px',
            '--text-padding-x': icon && !putIconOutside ? '2px' : '10px',
            '--icon-size': icon ? '18px' : '0px',
            '--icon-padding-x': icon ? '6px' : '0px',
            '--icon-padding-y': icon ? '6px' : '0px',
            '--separator-space': iconSeparator ? '7px' : '0px',
            '--font-size': '12px',
            '--outside-icon-space': putIconOutside ? '30px' : '0px',
          }
        case 'large':
          return {
            '--height': '36px',
            '--text-padding-x': icon && !putIconOutside ? '3px' : '12px',
            '--icon-size': icon ? '22px' : '0px',
            '--icon-padding-x': icon ? '7px' : '0px',
            '--icon-padding-y': icon ? '7px' : '0px',
            '--separator-space': iconSeparator ? '8px' : '0px',
            '--font-size': '14px',
            '--outside-icon-space': putIconOutside ? '36px' : '0px',
          }
        case 'x-large':
          return {
            '--height': '40px',
            '--text-padding-x': icon && !putIconOutside ? '3px' : '13px',
            '--icon-size': icon ? '23px' : '0px',
            '--icon-padding-x': icon ? '8px' : '0px',
            '--icon-padding-y': icon ? '9px' : '0px',
            '--separator-space': iconSeparator ? '9px' : '0px',
            '--font-size': '14px',
            '--outside-icon-space': putIconOutside ? '40px' : '0px',
          }
        case 'xx-large':
          return {
            '--height': '45px',
            '--text-padding-x': icon && !putIconOutside ? '3px' : '13px',
            '--icon-size': icon ? '24px' : '0px',
            '--icon-padding-x': icon ? '9px' : '0px',
            '--icon-padding-y': icon ? '11px' : '0px',
            '--separator-space': iconSeparator ? '10px' : '0px',
            '--font-size': '14px',
            '--outside-icon-space': putIconOutside ? '44px' : '0px',
          }
        case 'xxx-large':
          return {
            '--height': '50px',
            '--text-padding-x': icon && !putIconOutside ? '4px' : '14px',
            '--icon-size': icon ? '25px' : '0px',
            '--icon-padding-x': icon ? '9px' : '0px',
            '--icon-padding-y': icon ? '12px' : '0px',
            '--separator-space': iconSeparator ? '10px' : '0px',
            '--font-size': '14px',
            '--outside-icon-space': putIconOutside ? '48px' : '0px',
          }
        default:
          return {}
      }
    },
  },
}
